import {ReachTemplateContentChannel} from "../../apis/requests/templates/types";
import {NumPerChannel} from "../../apis/requests/audiences/types";

export const TEMPLATE_CHANNEL_ORDER: ReachTemplateContentChannel[] = [
  "email",
  "sms",
  "sms_with_landing_page",
  "mms",
  "mms_with_landing_page",
  "whatsapp",
];

export const sumTemplatesPerChannel = (counts: NumPerChannel): number =>
  TEMPLATE_CHANNEL_ORDER.reduce((total, channel) => total + counts[channel], 0);

export const DEFAULT_PAGE_SIZE = 10;
